import { CoreIconButton, CoreIconButtonMenu } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./IconButtonMenu.styled";
import type { IconButtonMenuItem } from "./IconButtonMenu.types";
import { Menu, type MenuProps } from "../Menu";
import { Typography } from "../Typography";

export type IconButtonMenuProps = Omit<
  MenuProps<IconButtonMenuItem>,
  "offset" | "padding" | "renderListItemContent"
> & {
  variant?: CoreIconButton.Variant;
};

function IconButtonMenu(props: IconButtonMenuProps) {
  const {
    variant = CoreIconButton.DEFAULT_VARIANT,
    testID = "icon-button-menu",
    ...menuProps
  } = props;

  const { tokens } = useDesignTokens();
  const { iconButtonMenu } = tokens;

  return (
    <Menu
      {...menuProps}
      offset={CoreIconButtonMenu.VARIANT_OFFSET[variant]}
      padding={CoreIconButtonMenu.VARIANT_PADDING[variant]}
      renderListItemContent={(item: IconButtonMenuItem) => (
        <S.Content $withIcon={item.icon !== undefined}>
          {item.icon && (
            <S.ContentIconWrapper aria-hidden="true">
              {item.icon}
            </S.ContentIconWrapper>
          )}

          <Typography
            color="inherit"
            variant={iconButtonMenu.menu.item.content.text.typography.variant}
            fontFamily={
              iconButtonMenu.menu.item.content.text.typography.fontFamily
            }
          >
            {item.text}
          </Typography>
        </S.Content>
      )}
      testID={testID}
    />
  );
}

export default IconButtonMenu;
